import { Configuration, RetailersApi } from '@/api';
import { productListQueryKeys } from '@/api/queries/productListQueryKeys';
import AdditiveComboBox from '@/components/select/AdditiveComboBox';
import { AdditiveComboBoxProps } from '@/components/select/ComboBox';
import { Retailer } from '@/models/Retailer';
import { useAuth } from '@/modules/auth/contexts/AuthContext';

export interface RetailerAdditiveComboBoxItem {
  id: string;
  name: string;
  retailer: Retailer;
}

interface RetailerAdditiveComboBoxProps extends Omit<
  AdditiveComboBoxProps<RetailerAdditiveComboBoxItem>,
  'queryFn' | 'queryKey'
> {
  supplierId?: string;
  productListId?: string;
}

const RetailerAdditiveComboBox = ({
  supplierId,
  productListId,
  selectedIds,
  ...props
}: RetailerAdditiveComboBoxProps) => {
  const retailersApi = new RetailersApi(new Configuration(useAuth));
  const findRetailers = async (query = ''): Promise<RetailerAdditiveComboBoxItem[]> => {
    if (!supplierId) return [];
    const response = await retailersApi.findRetailers(query, 0, 10, undefined, {
      supplierId,
      supplierRetailerStatus: 'ACTIVE',
      productListId,
      exclude: Boolean(productListId),
    });
    return response.items.map((retailer) => ({
      id: retailer.id,
      name: retailer.name,
      retailer,
    }));
  };

  return (
    <AdditiveComboBox<RetailerAdditiveComboBoxItem>
      label="Retailers:"
      placeholder="Search retailers"
      {...props}
      name="retailer"
      selectedIds={selectedIds}
      queryFn={findRetailers}
      queryKey={[
        ...productListQueryKeys.retailerAssignmentOptions(productListId ?? ''),
        supplierId ?? '',
        'ACTIVE',
        ...(selectedIds ?? []).map(String),
      ]}
    />
  );
};

export default RetailerAdditiveComboBox;
